import React from 'react';
import { Text } from '@applane/react-core-components';
import { cancelButton, save } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import DealerSettingScreen from '../ManageDealers/Setting';
import vars from '../../theme/vars';
import { SASetting } from './SA';

const { headings } = vars;
export default {
  [ROUTES.SuperAdminSettings.name]: {
    screen: SASetting,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Settings</Text>
    ),
    headerActions: [save],
  },

  [ROUTES.dealerSettings.name]: {
    screen: DealerSettingScreen,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Settings</Text>
    ),
    headerActions: [save],
  },

  [ROUTES.dealerSettingsBack.name]: {
    screen: DealerSettingScreen,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Settings</Text>
    ),
    headerActions: [cancelButton, save],
  },
};
